export default class ApiForbiddenError extends Error {}
